import type { Itinerary } from '../../models/Itinerary.model.ts';
import type { SupabaseClient } from '@supabase/supabase-js';
import { SupabaseRepository } from '../supabaseRepository/SupabaseRepository.ts';

const selector = `
  id,
  user_id,
  trip_id,
  data,
  is_generating,
  image,
  image_alt,
  image_provider,
  image_provider_id,
  image_photographer_name,
  image_photographer_url,
  image_source_url,
  is_generating_image,
  failed_generation,
  failed_image_generation,
  refinements_count,
  cody_suggestions,
  cody_suggestions_pending,
  cody_suggestions_requested_at,
  created_at,
  updated_at
`;

export class ItineraryRepository extends SupabaseRepository<Itinerary> {
  constructor(client: SupabaseClient) {
    super('itineraries', selector, client);
  }
}
